import { Button, ShyScrollbar } from '@cycle-app/ui';
import { InfoIconOutline } from '@cycle-app/ui/icons';
import { Color } from '@cycle-app/ui/theme/baseColors';
import styled, { css } from 'styled-components';

export const StyledInfoIconOutline = styled(InfoIconOutline)`
  height: 12px;
  width: 12px;
`;

export const ToggleButton = styled(Button)`
  margin-top: 16px;
  height: 32px;
`;

export const ListContainer = styled(ShyScrollbar)`
  max-height: 390px;
`;

export const List = styled.ul`
  margin-top: 12px;
`;

export const Item = styled.li`
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding-top: 8px;
  padding-bottom: 8px;

  &:not(:first-child) {
    border-top: 1px solid ${p => p.theme.colors.border.primary};
  }
`;

export const Name = styled.div<{ $isDisabled?: boolean }>`
  align-items: center;
  display: flex;
  gap: 6px;
  text-align: left;
  overflow: hidden;
  color: ${Color.Grey600};
  ${p => p.$isDisabled && css`color: ${Color.Grey200};`}
`;

export const NameLabel = styled.div`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;
